import Widget from '../../BookOnline/Widget';

export default Widget;
